import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";

export enum LogType {
	INFO = 1,
	WARN = 2,
	ERROR = 3
}

class LoggerServiceClass {
	public readonly url = `${ServerConfig.host}/logger`

	public async createLog(message:string, stack:string, logType:LogType) {
		await Axios.post(`${this.url}`, {
			Message: message,
			Stack: stack,
			Type: logType
		});
	}
}

export const LoggerService = new LoggerServiceClass();